import { UserPartnershipApplicationStatus } from "./enums/UserPartnershipApplicationStatus";
var UserPartnershipApplication = /** @class */ (function () {
    function UserPartnershipApplication(data) {
        var _a, _b, _c, _d, _e;
        this.id = data.id;
        this.mgmt_code = data.mgmt_code;
        this.partnership_service_id = data.partnership_service_id;
        this.user_id = data.user_id;
        this.status = (_a = data.status) !== null && _a !== void 0 ? _a : UserPartnershipApplicationStatus.PENDING;
        this.personal_information_agreed_at = (_b = data.personal_information_agreed_at) !== null && _b !== void 0 ? _b : null;
        this.third_party_sharing_agreed_at = (_c = data.third_party_sharing_agreed_at) !== null && _c !== void 0 ? _c : null;
        this.user = (_d = data.user) !== null && _d !== void 0 ? _d : null;
        this.file_metas = (_e = data.file_metas) !== null && _e !== void 0 ? _e : [];
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
    }
    UserPartnershipApplication.from = function (data) {
        return new UserPartnershipApplication(data);
    };
    return UserPartnershipApplication;
}());
export { UserPartnershipApplication };
/**
 * @description 빈 데이터 생성 함수
 * @returns
 */
export var createEmptyApplication = function () { return ({
    id: 0,
    mgmt_code: '',
    partnership_service_id: 0,
    user_id: 0,
    status: UserPartnershipApplicationStatus.PENDING,
    personal_information_agreed_at: null,
    third_party_sharing_agreed_at: null,
    user: null,
    file_metas: [],
    created_at: '',
    updated_at: '',
}); };
